<template>
  <div class="flex flex-col">
    <div class="flex items-center">
      <img 
        :class="[
          isCompanyPage && footer ? 'h-[24px] w-[24px]' : 'h-[32px] w-[32px]'
        ]" 
        src="@/assets/img/common/logo.svg" 
        alt="Logo BCompliance" 
        loading="lazy" 
      />
      <div 
        :class="[
          'ml-3 font-[\'MuseoModerno\'] font-semibold tracking-[-1%] leading-[100%]',
          isCompanyPage && footer ? 'text-[16px]' : 'text-[22px]'
        ]"
      >
        <router-link to="/"
          class="text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-blue-500">BCompliance&Law</router-link>
      </div>
    </div>
    <div class="text-black text-left text-[10px] mt-5" v-if="footer && !isCompanyPage">
      <p>BC TECNOLOGIA DA INFORMAÇÃO LTDA.</p>
      <p>CNPJ: 41.507.721/0001-70</p>
      <a target="_blank" class="text-[#2E6DD1] underline hover:text-[#245ab3]"
        href="https://goo.gl/maps/fuEGa7V8b8dRRHaR7">
        <p class="bg-clip-text">
          Rua Eugenio Rabello, nº 98
        </p>
        <p class="bg-clip-text">
          Jardim Embaixador, Sorocaba-SP
        </p>
        <p class="bg-clip-text">
          CEP: 18040-436
        </p>
      </a>

      <p>
        <a target="_blank" class="text-[#2E6DD1] underline hover:text-[#245ab3] bg-clip-text"
          href="tel:+5515998341602">(15) 998341602</a>
      </p>
      <p>
        <a target="_blank" class="text-[#2E6DD1] underline hover:text-[#245ab3] font-[600]"
          href="mailto:contato@bcompliance.com.br">
          contato@bcompliance.com.br
        </a>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    footer: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    isCompanyPage() {
      // Verifica se a rota atual corresponde ao padrão /empresas/ID
      return /^\/empresas\/[a-zA-Z0-9]+/.test(this.$route.path);
    }
  }
};
</script>
